/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import { defaultPersonData } from '../../utils/store';

const form5Slice = createSlice({
  name: 'form5',
  initialState: {
    data: {
      samePerson: '',
      personType: '',
      ...defaultPersonData,
    },
    state: {},
    municipality: {},
  },
  reducers: {
    setFormData(state, { payload }) {
      state.data = payload;
    },
    setSamePerson(state, { payload }) {
      state.data.samePerson = payload.samePerson;
    },
    setStateAndMunicipality(state, { payload }) {
      state.state = payload.state;
      state.municipality = payload.municipality;
    },
  },
});

export const form5Actions = form5Slice.actions;

export default form5Slice;
/* eslint-enable no-param-reassign */
